import { defaultInitialState } from '../utils';
import { UPDATE_PASSWORD_PARAMS, UPDATE_PASSWORD_DONE, UPDATE_PASSWORD_ERROR, UPDATE_PASSWORD_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_PASSWORD_PARAMS:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: false, errorMessage: null });
        case UPDATE_PASSWORD_DONE:
            return Object.assign(Object.assign({}, state), { isUpdated: true, isLoading: false, error: false, errorMessage: null });
        case UPDATE_PASSWORD_ERROR:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: true, errorMessage: action.data.msg });
        case UPDATE_PASSWORD_RESET:
            return initialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map